import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Board & Trains', path: '/board-and-trains' },
    { name: 'City Dog Board & Train', path: '/city-dog-board-train' },
    { name: 'In Home Programs', path: '/in-home-programs' },
    { name: 'Puppy Program', path: '/puppy-program' },
    { name: 'Feral Dog Rehab', path: '/feral-dog-rehab' },
    { name: 'About Us', path: '/about' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* Main Header */}
      <header className="bg-white shadow-md sticky top-0 z-50">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="/assets/images/logo-color.jpg" 
                alt="Farm Dog Oklahoma Logo" 
                className="h-16 w-16 object-contain"
              />
              <div>
                <h1 className="text-2xl font-bold text-[#5C4033]" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Farm Dog Oklahoma
                </h1>
                <p className="text-xs text-[#C4A052] font-semibold">Transforming Rascals into Reliable Companions</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden xl:flex items-center gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-xs font-medium transition-colors relative group whitespace-nowrap ${
                    isActive(link.path) ? 'text-[#C4A052]' : 'text-[#5C4033] hover:text-[#C4A052]'
                  }`}
                >
                  {link.name}
                  <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-[#C4A052] transform origin-left transition-transform ${
                    isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'
                  }`}></span>
                </Link>
              ))}
            </nav>

            {/* Call Now Button */}
            <a 
              href="tel:+19189927332" 
              className="hidden xl:block flex-shrink-0"
            >
              <Button className="bg-gradient-to-r from-[#C4A052] to-[#B8935E] hover:from-[#B8935E] hover:to-[#C4A052] text-white font-semibold px-6 py-2 rounded-lg transition-all duration-300 hover:shadow-lg">
                Call Now
              </Button>
            </a>

            {/* Mobile Menu Button */}
            <button
              className="xl:hidden text-[#5C4033]"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <nav className="xl:hidden pb-4 space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`block py-2 px-4 rounded transition-colors ${
                    isActive(link.path)
                      ? 'bg-[#C4A052] text-white'
                      : 'text-[#5C4033] hover:bg-[#F5F5F0]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a 
                href="tel:+19189927332" 
                className="block"
              >
                <Button className="w-full bg-gradient-to-r from-[#C4A052] to-[#B8935E] text-white font-semibold">
                  Call Now
                </Button>
              </a>
            </nav>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;